"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerList", {
    enumerable: true,
    get: function() {
        return TagPickerList;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerList = require("./useTagPickerList");
const _renderTagPickerList = require("./renderTagPickerList");
const _useTagPickerListStylesstyles = require("./useTagPickerListStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerList = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerList.useTagPickerList_unstable)(props, ref);
    (0, _useTagPickerListStylesstyles.useTagPickerListStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerListStyles_unstable')(state);
    return (0, _renderTagPickerList.renderTagPickerList_unstable)(state);
});
TagPickerList.displayName = 'TagPickerList';
